import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import View from '../view';
import { pxTransform } from '../../common/utils';

interface ILoadingProps {
  /**
   * css class
   */
  className?: string;
  /**
   * 尺寸，若传入的为 number 类型，则调用 pxTransform(size) 计算
   */
  size?: number | string;
  /**
   * 自定义颜色
   */
  color?: string;
  /**
   * 是否水平排列图标和文字内容
   * @default false
   */
  horizontal?: boolean;
}

const Loading: FC<PropsWithChildren<ILoadingProps>> = ({ className, children, size, color, horizontal = false }) => {
  const rootCls = classNames(['ink-loading', { 'ink-loading--horizontal': horizontal }, className]);

  const realSize = size && (typeof size === 'string' ? size : pxTransform(size));
  const sizeStyle = {
    ...(realSize ? { width: realSize, height: realSize } : {}),
  };
  const colorStyle = {
    ...(color ? { borderColor: `${color} ${color} transparent` } : {}),
  };
  const spinStyle = { ...sizeStyle, ...colorStyle };

  return (
    <View className={rootCls}>
      <View className="ink-loading__spin" style={spinStyle} />
      {children && <View className="ink-loading__text">{children}</View>}
    </View>
  );
};

export default Loading;
